import type { PickedFile as CapacitorFile } from '@capawesome/capacitor-file-picker'
export type { PickedFile as PickFile } from '@capawesome/capacitor-file-picker'
import { captureError } from '@/core/errors'

/**
 * @description
 * HTML5のinput要素を使用してファイルを選択し、
 * Capacitor File Picker互換のオブジェクトを返す。
 *
 * @param types - 受け入れ可能なファイルタイプの配列（MIME typeまたは拡張子）
 * @returns Promise<CapacitorFile> - 選択されたファイル情報
 */
export const pickFile = async (types: string[]): Promise<CapacitorFile> => {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = types.join(',')
    input.multiple = false

    input.onchange = event => {
      const file = (event.target as HTMLInputElement).files?.[0]

      if (!file) {
        reject(new Error('キャンセルしました。もう一度お試しください。'))
        return
      }

      try {
        const pickedFile: CapacitorFile = Object.assign(file, {
          mimeType: file.type,
        })

        resolve(pickedFile)
      } catch (error) {
        captureError(error as Error, 'pickFileWeb')
        reject(error)
      }
    }

    input.click()
  })
}
